import { render, staticRenderFns } from "./water_left.vue?vue&type=template&id=15202861&scoped=true&"
import script from "./water_left.vue?vue&type=script&lang=js&"
export * from "./water_left.vue?vue&type=script&lang=js&"
import style0 from "./water_left.vue?vue&type=style&index=0&id=15202861&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15202861",
  null
  
)

export default component.exports